import { Box, Typography, useTheme } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { dayjs, isNotNullOrUndefined } from '@weft/utils';
import React from 'react';

type DynamicInvoiceApprovedLabelProps = {
  approvedAt?: Date;
};

export const DynamicInvoiceApprovedLabel: React.FC<DynamicInvoiceApprovedLabelProps> = ({ approvedAt }) => {
  const vyTheme = useTheme();

  const approvalMessage = isNotNullOrUndefined(approvedAt) 
    ? `${dayjs(approvedAt).format('DD.MM.YYYY HH:mm')}` 
    : 'Approved';
  
  return (
    <Box
      height="42px"
      bgcolor={vyTheme.palette.success.hover}
      padding="6px 16px 6px 16px"
      marginLeft='auto'
      display="flex"
      gap={1}
      alignItems="center"
    >
      <VyIcon
        icon='CheckCircle'
        color={vyTheme.palette.success.dark}
      />
      <Typography
        fontWeight={500}
        fontSize="14px"
        lineHeight="24px"
        bgcolor="transparent"
        color={vyTheme.palette.success.dark}
      >
        {approvalMessage}
      </Typography>
    </Box>
  );
};